import { io } from "socket.io-client";
import { getAccessToken, getNormalizedApiBaseUrl } from "../utils/backendApi";

let socket = null;

const getServerBaseUrl = () => getNormalizedApiBaseUrl().replace(/\/api\/v\d+\/?$/, "");

export const getAdminChatSocket = () => {
  const token = getAccessToken();
  if (!token) {
    throw new Error("Session expirée");
  }

  if (socket?.connected) {
    return socket;
  }

  socket = io(getServerBaseUrl(), {
    path: "/ws/chat",
    auth: { token },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });

  return socket;
};

export const disconnectAdminChatSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const subscribeAdminChatEvents = (sock, callbacks) => {
  if (callbacks.onHistory) sock.on("messages:history", callbacks.onHistory);
  if (callbacks.onNewMessage) sock.on("message:new", callbacks.onNewMessage);
  if (callbacks.onTypingStart) sock.on("typing:start", callbacks.onTypingStart);
  if (callbacks.onTypingStop) sock.on("typing:stop", callbacks.onTypingStop);
  if (callbacks.onError) sock.on("error", callbacks.onError);
};

export const unsubscribeAdminChatEvents = (sock) => {
  if (!sock) return;
  sock.off("messages:history");
  sock.off("message:new");
  sock.off("typing:start");
  sock.off("typing:stop");
  sock.off("error");
};

export const joinAdminConversation = (sock, conversationId) => {
  sock.emit("join", Number(conversationId));
};

export const leaveAdminConversation = (sock, conversationId) => {
  sock.emit("leave", Number(conversationId));
};

export const sendAdminSocketMessage = (sock, payload) => {
  sock.emit("message:send", {
    conversationId: Number(payload.conversationId),
    content: payload.content,
    ...(payload.replyToId ? { replyToId: Number(payload.replyToId) } : {}),
  });
};

export const emitAdminTypingStart = (sock, conversationId) => {
  sock.emit("typing:start", Number(conversationId));
};

export const emitAdminTypingStop = (sock, conversationId) => {
  sock.emit("typing:stop", Number(conversationId));
};
